export default "__VITE_ASSET__Djvbz77s__"